module.exports = __webpack_public_path__ + "static/media/facebook-logo.ea106d23.svg";